import ui from './ui';
import submission from './submission';
import { version } from './version';

export {
	ui,
	version,
	submission,
};



// WEBPACK FOOTER //
// ./src/reducers/index.js